<template>
  <div class="min-h-screen bg-white pb-16">
    <Preview v-if="accOrder" :acc-order="accOrder" />
  </div>
</template>

<script>
import Preview from 'Components/AccOrder/Preview.vue';

export default {
  components: {
    Preview,
  },
  props: {
    accOrderId: {
      type: String,
      required: true,
    },
  },
  computed: {
    accOrder() {
      return this.$store.state.entities.accOrders.byId[this.accOrderId];
    },
  },
  created() {
    this.fetchOrder();
  },
  methods: {
    async fetchOrder() {
      try {
        await this.$store.dispatch('ui/accOrders/read', {
          id: this.accOrderId,
          query: {
            include: 'products,lineItems,contact',
          },
        });
      } catch (error) {
        //
      }
    },
  },
};
</script>
